import userQuery from './userQuery';
import setDepartment from './setDepartment';
import userCreate from './userCreat';
import userInfo from './userInfo';
import userUpdate from './userUpdate';
import userPreCheck from './userPreCheck';
import checkUserExist from './checkUserExist';
import userBatchCreate from './userBatchCreate';
import userBatchPreTreated from './userBatchPreTreated';
import securityMgrGet from './securityMgrGet';
import securityMgrUnlock from './SecurityMgrUnlock';
import userInviteCancel from './userInviteCancel';

export default {
    userQuery,
    setDepartment,
    userCreate,
    userInfo,
    userUpdate,
    userPreCheck,
    /** 批量上传，创建用户 */
    userBatchCreate,
    /** 批量上传，创建用户，预检查 */
    userBatchPreTreated,
    securityMgrGet,
    securityMgrUnlock,
    userInviteCancel,
    checkUserExist
};



// WEBPACK FOOTER //
// ./src/api/systemManage/userManage/index.ts